module.exports = __webpack_public_path__ + "img/logo.ad9920cc.png";